<div fxFlex="0 0">
	<app-note
		[noteType]="noteType"
		[active]="active"
		[id]="id"
		[supportId]="supportId"
		[loadId]="loadId"
		[carrierId]="carrierId"
		[name]="name"
		[feedbackInformation]="feedbackInformation"
		[showFeedback]="showFeedback"
		(cancelClicked)="cancelClicked.emit(false)"
		(noteAdded)="noteAdded.emit($event)"
		(feedbackAdded)="feedbackAdded.emit($event)"
		[origin]="origin"
		[truckLaneId]="truckLaneId"
		[destination]="destination"
	>
	</app-note>

	<div
		*ngIf="!active"
		(click)="textAreaClicked.emit()"
		class="font-size-14 padding-0-5 cursor-pointer input-box m-5"
	>
		Start typing to add a note...
	</div>
</div>
